import { render, staticRenderFns } from "./ModalSupplier.vue?vue&type=template&id=104c8b63&scoped=true&"
import script from "./ModalSupplier.vue?vue&type=script&lang=js&"
export * from "./ModalSupplier.vue?vue&type=script&lang=js&"
import style0 from "./ModalSupplier.vue?vue&type=style&index=0&id=104c8b63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c8b63",
  null
  
)

export default component.exports